// app/javascript/components/TopNavbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { t, currentLocale } from '../utils/i18n';

const TopNavbar = ({ user, onNavigate, onLogout, api }) => {
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    fetchNotifications();
    fetchUnreadCount();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (notificationDropdownRef.current && !notificationDropdownRef.current.contains(event.target)) {
        setNotificationDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await api.get('/notifications');
      setNotifications(response.data.notifications || []);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchUnreadCount = async () => {
    try {
      const response = await api.get('/notifications/unread_count');
      setUnreadCount(response.data.count || 0);
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      await api.patch(`/notifications/${notificationId}/mark_as_read`);
      fetchNotifications();
      fetchUnreadCount();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      await api.patch('/notifications/mark_all_as_read');
      fetchNotifications();
      fetchUnreadCount();
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        await fetch('/api/v1/logout', {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear local storage and redirect
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('currentView');
      onLogout();
      window.location.href = '/';
    }
  };


  const changeLanguage = (locale) => {
    const currentPath = window.location.pathname.replace(/^\/(en|so)/, '');
    window.location.href = `/${locale}${currentPath}`;
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    setNotificationDropdownOpen(false);
  };

  const toggleNotificationDropdown = () => {
    setNotificationDropdownOpen(!notificationDropdownOpen);
    setDropdownOpen(false);
  };

  // Add this function in TopNavbar.jsx
  const deleteNotification = async (notificationId) => {
    try {
      await api.delete(`/notifications/${notificationId}`);
      fetchNotifications();
      fetchUnreadCount();
    } catch (error) {
      console.error('Error deleting notification:', error);
    }
  };

  return (
    <div className="dFlex topHdr">
      <button type="button" className="navbar-toggler menu-toggle" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
        aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon">
          <span className="bar1"></span>
          <span className="bar2"></span>
          <span className="bar3"></span>
        </span>
      </button>
      <div className="searchBox">
        <input type="text" placeholder="Search..." />
        <button type="button">
          <img src="/images/search1.png" alt="" />
        </button>
      </div>
      <div className="dFlex topHdrRight">
        {/* <a href="#" className="topHdrAnchors">
          <img src="/images/chat.png" alt="" />
        </a>*/}
        <div className="dropdown" style={{ position: 'relative' }} ref={notificationDropdownRef}>
          <a href="#" className={`topHdrAnchors ${unreadCount > 0 ? 'hasNotifications' : ''}`} onClick={(e) => { e.preventDefault(); toggleNotificationDropdown(); }}>
            <img src="/images/noti.png" alt="" />
            {unreadCount > 0 && <span className="notiDot">{unreadCount}</span>}
          </a>

          {notificationDropdownOpen && (
            <div className="dropdown-menu show" style={{ position: 'absolute', right: 0, top: '100%', maxHeight: '400px', overflowY: 'auto', zIndex: 1000, padding: '0px 10px 0px 0px' }}>
              <div className="dropdown-header d-flex justify-content-between">
                <span>Notifications</span>
                {unreadCount > 0 && (
                  <button className="btn btn-sm btn-link p-0" onClick={markAllAsRead} style={{ fontSize: '12px' }}>Mark all read</button>
                )}
              </div>
              {notifications.length === 0 ? (
                <div className="dropdown-item text-center text-muted">
                  No notifications
                </div>
              ) : (
                notifications.slice(0, 10).map(notification => (
                  <div
                    key={notification.id}
                    className={`dropdown-item ${notification.status === 'unread' ? 'bg-light' : ''}`}
                    style={{ cursor: 'pointer', borderBottom: '1px solid #eee', position: 'relative' }}
                  >
                    <div onClick={() => markAsRead(notification.id)}>
                      <div className="fw-bold" style={{ fontSize: '14px' }}>{notification.title}</div>
                      <div className="text-muted" style={{ fontSize: '12px' }}>{notification.message}</div>
                      <div className="text-muted" style={{ fontSize: '11px' }}>
                        {new Date(notification.created_at).toLocaleDateString()}
                      </div>
                    </div>
                    <button
                      onClick={(e) => { e.stopPropagation(); deleteNotification(notification.id); }}
                      style={{ position: 'absolute', top: '5px', right: '5px', border: 'none', background: 'none', color: '#999' }}
                    >
                      ×
                    </button>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <span className="topHdrAnchors" style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { document.getElementById('langSelect').focus(); document.getElementById('langSelect').click(); }}>
          <img src="/images/language.png" alt="" style={{ pointerEvents: 'none' }} />
          <select id="langSelect" value={currentLocale()} onChange={(e) => changeLanguage(e.target.value)} className="dropdown-item" style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', top: 0, left: 0, cursor: 'pointer' }}>
            <option value="en">English</option>
            <option value="so">Somali</option>
          </select>
        </span>
        <div className="dropdown topHdrDD" ref={dropdownRef}>
          <a className="dFlex dropdown-toggle" href="#" role="button" onClick={(e) => { e.preventDefault(); toggleDropdown(); }}>
            <img src="/images/solider.png" alt="" />
            <div className="topHdrDdInfo">
              <div className="fwMedium colorBlack">{user?.email || 'User'}</div>
              <span className="txt14 colorTextGray1">Admin</span>
            </div>
          </a>
          <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
            <li><a className="dropdown-item" type="button" onClick={() => onNavigate('profile')}>Profile</a></li>
            <li><a className="dropdown-item" href="#" onClick={handleLogout}>Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
